import React, { useEffect } from 'react';
import type { AppProps } from 'next/app';
import { useRouter } from 'next/router';
import type { Session } from 'next-auth';
import { SessionProvider } from 'next-auth/react';
import { initializeProductAvailabilityConfig, initializeProductConfig, Toaster } from '@loomstateorg/shared-frontend';
import { appWithTranslation } from 'next-i18next';
import 'tailwindcss/tailwind.css';
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-dates/lib/css/_datepicker.css';
import '../styles/app.css';
import { sdk } from 'sdk';
import { FrontasticProvider } from 'frontastic';
import Layout from './layout';

interface CustomAppProps extends AppProps {
  pageProps: {
    session?: Session;
    [key: string]: unknown;
  };
}

function FrontasticStarter({ Component, pageProps }: CustomAppProps) {
  const router = useRouter();

  sdk.configureForNext(router.locale as string);

  // Load product availability configuration on app start
  useEffect(() => {
    initializeProductAvailabilityConfig();
    initializeProductConfig();
  }, []);

  return (
    <SessionProvider session={pageProps.session}>
      <Layout>
        <FrontasticProvider>
          <Component {...pageProps} />
          <Toaster />
        </FrontasticProvider>
      </Layout>
    </SessionProvider>
  );
}

// eslint-disable-next-line @typescript-eslint/no-var-requires
export default appWithTranslation(FrontasticStarter as any, require('../next-i18next.config'));
